import { capture } from '../lib/posthog';

/**
 * Centralized PostHog event helpers.
 * Provides a stable API surface for analytics calls across the app.
 * Direct posthog.capture() calls in existing consumers are intentionally kept
 * (they work and are covered by existing tests) — this hook is for new code.
 */
export function usePostHogEvents() {
  return {
    trackPlayed: ({ track_id, source }) =>
      capture('track_played', { track_id, source }),
    trackSkipped: ({ track_id, position_seconds, reason }) =>
      capture('track_skipped', { track_id, position_seconds, reason }),
    trackLikedToggled: ({ track_id, liked }) =>
      capture('track_liked_toggled', { track_id, liked }),
    playlistEvent: ({ playlist_id, action }) =>
      capture('playlist_event', { playlist_id, action }),
    businessTypeChanged: ({ from, to }) =>
      capture('business_type_changed', { from, to }),
    subscriptionStarted: ({ plan, mrr_eur }) =>
      capture('subscription_started', { plan, mrr_eur }),
    savMessageSent: ({ category, escalated_to_human }) =>
      capture('sav_message_sent', { category, escalated_to_human }),
    zoneEvent: ({ zone_id, action, payload }) =>
      capture('zone_event', { zone_id, action, ...payload }),
    playlistPlayed: ({ playlist_id, source }) =>
      capture('playlist_played', { playlist_id, source }),
  };
}
